import type { BlockPre } from 'shared-types';

type LocaleData = BlockPre['locales'][string];

const defaultBlockData = {
  format: 'text' as const,
  showLineNumbers: false
};

const translatable: LocaleData['translatable'] = { text: '' };
const defaultLocaleData: LocaleData = { translatable };

const localePlaceholders = {
  text: '{{ locales.translatable.text }}' as const
};

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockPreData: BlockPre = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockPre['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
